import { forwardRef } from "react";

const CalendarInput = forwardRef(({ value, onChange, placeholder, id, min, max, readOnly }, ref) => {
    return (
        <div className="relative w-full">
            <input
                type="date"
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="form-input w-full pr-10"
                ref={ref}
                min={min}
                max={max}
                readOnly={readOnly}
            />
        </div>
    );
});

export default CalendarInput;
